const Tabbar = () => import(/* webpackChunkName: "Tabbar" */ '@/components/tabBar');

export default [
  {
    path: '/followArticle',
    name: 'followArticleLayout',
    redirect: { name: 'followArticle' },
    component: () => import('@/views/layout'),
    children: [
      {
        path: 'list',
        name: 'followArticle',
        components: {
          default: () => import('@/views/followArticle'),
          tabbar: Tabbar
        },
        meta: {
          keepAlive: true,
          includeKeepAlive: ['personal', 'detail']
        }
      }
    ]
  }
]